import React from 'react';
import {
  Grid, Container,
  //  Input, InputAdornment
} from '@material-ui/core';
import Logo1 from '../.../../../../../assets/images/logo.png';
import Logo2 from '../.../../../../../assets/images/logo-1.png';
import Branch from '../../../../models/branch.model';
// import {FiSearch} from 'react-icons/fi';
import { lang } from '../../../../config/app.config';
import { Link } from 'react-router-dom';
import translates from '../../../../translation.json';
import { useSelector } from 'react-redux';
import { TranslationState } from '../../../../store/ActionReducers/translation.actionreducer';


interface PI {
  branch?: Branch | undefined,
  isMainSite?: boolean | undefined
}

const LogoSearch: React.FC<PI> = (props) => {
  const stateTr = useSelector((state: { translation: TranslationState }) => state.translation);

  const { branch, isMainSite } = props;
  return (
    <div className="ecn-logo-searchbar">
      <Container maxWidth="lg">
        <Grid container alignItems="center">
          <Grid item xs={12} md={4} lg={4} xl={4} style={{ display: 'flex', alignItems: 'center' }}>
            <div className="logo">
              {branch ?
                <Link to={isMainSite ? '/' : `/${lang}/district/${branch.slug}`}>
                  <img src={Logo1} alt="logo1" />
                </Link> :
                <Link to={`/${lang}`}>
                  <img src={Logo1} alt="logo1" />
                </Link>
              }
            </div>
          </Grid>

          <Grid item xs={6} md={4} lg={4} xl={4}>
            {
              branch && !isMainSite ?
                <div>
                  {/* <h3 className="text-12-secondary">{translate.translation[lang].government_of_nepal}</h3> */}
                  <h2 className="text-26-secondary bold text-center header-title header-title-office">

                    {(branch.district && branch.district.length) ? stateTr.translation ? stateTr.translation.district_title[lang === 'np' ? "value_np" : "value_en"] : ""
                      :
                      stateTr?.translation ? stateTr?.translation?.province_title[lang === 'np' ? "value_np" : "value_en"] : ""}

                  </h2>
                  <p className="text-center header-sub header-district-name">
                    {/* {branch.district || branch.province || ""} */}
                    {branch?.translations[0]?.office_address ?? (branch.district || branch.province)}
                  </p>
                </div>
                : <div>
                  {/* <h3 className="text-12-secondary">{translate.translation[lang].government_of_nepal}</h3> */}
                  <h2 className="text-26-secondary bold text-center header-title">{translates.translation[lang].election_commission}</h2>
                  <p className="text-16-grey text-center header-sub">
                    {branch?.translations[0]?.office_address ?? translates.translation[lang].location}
                  </p>
                </div>
            }
          </Grid>

          <Grid item xs={6} md={4} lg={4} xl={4}>
            <div className="logo display-flex justify-content-end">
              <img src={Logo2} alt="logo2" style={{ width: '250px' }} />
            </div>
          </Grid>

          {/* <Grid item xs={12} md={4} lg={4} xl={4} className="text-center">
            <div className="search">
              <Input
                placeholder={lang === 'np'?"तपाईँ के खोज्दै हुनुहुन्छ ?":"What are you looking for?"}
                className="search-input"
                endAdornment={<InputAdornment position="end"><FiSearch className="icon"/></InputAdornment>}
              />
            </div>
          </Grid> */}
        </Grid>
      </Container>
    </div >
  );
}

export default LogoSearch;